import api from '@/services/api'

const sendComment = async form => {
    try {
        const resp = await api.post('comments', form)

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

const saveAnswers = async (feedbackId, form) => {
    try {
        const resp = await api.put(`feedbacks/${feedbackId}`, form)

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

const archiveFeedback = async feedbackId => {
    try {
        const resp = await api.delete(`feedbacks/${feedbackId}`)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

const unarchiveFeedback = async feedbackId => {
    try {
        const resp = await api.put(`feedbacks/${feedbackId}/restore`)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export { sendComment, saveAnswers, archiveFeedback, unarchiveFeedback }
